"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BulletChart = void 0;
var tslib_1 = require("tslib");
// (C) 2019 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var sdk_model_1 = require("@gooddata/sdk-model");
var sdk_ui_1 = require("@gooddata/sdk-ui");
var interfaces_1 = require("../../interfaces");
var truncate_1 = require("../_commons/truncate");
var CoreBulletChart_1 = require("./CoreBulletChart");
var dimensions_1 = require("../_commons/dimensions");
var withChart_1 = require("../_base/withChart");
var sanitizeStacking_1 = require("../_commons/sanitizeStacking");
//
// Internals
//
var bulletChartDefinition = {
    chartName: "BulletChart",
    bucketPropsKeys: ["primaryMeasure", "targetMeasure", "comparativeMeasure", "viewBy", "filters", "sortBy"],
    propTransformation: function (props) {
        /*
         * Modify input props - disable compute ratio on all measures
         */
        return tslib_1.__assign(tslib_1.__assign({}, props), { primaryMeasure: sdk_model_1.disableComputeRatio(props.primaryMeasure), targetMeasure: props.targetMeasure
                ? sdk_model_1.disableComputeRatio(props.targetMeasure)
                : undefined, comparativeMeasure: props.comparativeMeasure
                ? sdk_model_1.disableComputeRatio(props.comparativeMeasure)
                : undefined });
    },
    bucketsFactory: function (props) {
        var viewBy = truncate_1.truncate(props.viewBy, interfaces_1.ViewByAttributesLimit);
        return [
            sdk_model_1.newBucket(sdk_ui_1.BucketNames.MEASURES, props.primaryMeasure),
            sdk_model_1.newBucket(sdk_ui_1.BucketNames.SECONDARY_MEASURES, props.targetMeasure),
            sdk_model_1.newBucket(sdk_ui_1.BucketNames.TERTIARY_MEASURES, props.comparativeMeasure),
            sdk_model_1.newBucket.apply(void 0, tslib_1.__spreadArrays([sdk_ui_1.BucketNames.VIEW], viewBy)),
        ];
    },
    executionFactory: function (props, buckets) {
        var _a;
        var backend = props.backend, workspace = props.workspace, execConfig = props.execConfig;
        return (_a = backend
            .withTelemetry("BulletChart", props)
            .workspace(workspace)
            .execution()
            .forBuckets(buckets, props.filters))
            .withSorting.apply(_a, props.sortBy).withDimensions(dimensions_1.stackedChartDimensions)
            .withExecConfig(execConfig);
    },
    propOverridesFactory: function (props, _buckets) {
        return {
            config: sanitizeStacking_1.sanitizeConfig([
                props.primaryMeasure,
                props.targetMeasure,
                props.comparativeMeasure,
            ], props.config),
        };
    },
};
var WrappedBulletChart = withChart_1.withChart(bulletChartDefinition)(CoreBulletChart_1.CoreBulletChart);
/**
 * [BulletChart](http://sdk.gooddata.com/gooddata-ui/docs/bullet_chart_component.html)
 *
 * Bullet chart is a variation of a bar chart that displays performance of a measure (primary measure) and its progress
 * towards a goal (target measure). Optionally, the primary measure can also be compared to another measure (comparative measure).
 *
 * @public
 */
exports.BulletChart = function (props) {
    var _a = sdk_ui_1.useResolveValuesWithPlaceholders([
        props.primaryMeasure,
        props.targetMeasure,
        props.comparativeMeasure,
        props.viewBy,
        props.filters,
        props.sortBy,
    ], props.placeholdersResolutionContext), primaryMeasure = _a[0], targetMeasure = _a[1], comparativeMeasure = _a[2], viewBy = _a[3], filters = _a[4], sortBy = _a[5];
    return (react_1.default.createElement(WrappedBulletChart, tslib_1.__assign({}, props, {
        primaryMeasure: primaryMeasure,
        targetMeasure: targetMeasure,
        comparativeMeasure: comparativeMeasure,
        viewBy: viewBy,
        filters: filters,
        sortBy: sortBy,
    })));
};
//# sourceMappingURL=BulletChart.js.map